import { AccordionSummary, Box, Button, Stack, Switch, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AIToggle from './AIToggle';
import { Link } from 'react-router-dom';
import { useAiAvailable } from '@/utils/ai';

const AISettings = () => {
  const { t } = useTranslation();
  // Utan nyckel i miljön finns varken AI-toggeln eller AI-profilen att ställa in.
  // Accordion-posten gatas dessutom i SettingsAccordionConfig, så rubriken försvinner
  // också - annars hade man klickat upp en tom låda.
  const aiAvailable = useAiAvailable();

  if (!aiAvailable) return null;

  return (
    <Stack>
      <AIToggle />
      <Box
        sx={{
          p: 2,
          display: 'flex',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <Stack
          justifyContent={'space-between'}
          direction={'row'}
          width={'100%'}
          alignItems={'center'}
        >
          <Typography variant="h6" color={'primary'}>
            {t('AI Profile')}
          </Typography>
          <Button component={Link} to="/ai-profile" variant={'outlined'} color={'primary'}>
            {t('Configure')}
          </Button>
        </Stack>
      </Box>
    </Stack>
  );
};

export default AISettings;
